(() => {
  const config = document.getElementById('app-widget-translations');
  if (!config) return;
  const entities = { '&amp;': '&', '&quot;': '"', '&#39;': "'", '&lt;': '<', '&gt;': '>' };
  const text = Object.fromEntries(Object.entries(JSON.parse(config.textContent)).map(([key, value]) => [key, typeof value === 'string' ? value.replace(/&amp;|&quot;|&#39;|&lt;|&gt;/g, entity => entities[entity]) : value]));
  const scope = '.AlLo-product-block, .AlLo-widget, .ahlGiftBnrTitle, .ahlGiftPopSubTitle, .ahlGiftPopBtn, .ahlGiftBnrPrdTitle, .ahlGiftPopPrdTitle, .ahlGiftBnrImg, .jdgm-widget, .swatch-view-item';
  const clubLabels = new Map([
    ["Loading...", "club_loading"],
    ["LSDS CLUB Avantajlar Dünyasına Hoş Geldiniz", "club_welcome"],
    ["Avantajlar Dünyasına Hoş Geldiniz!", "club_welcome_short"],
    ["LSDS CLUB'a KATILIN", "club_join_title"],
    ["AYRICALIKLI MÜŞTERİLERİMİZDEN BİRİ OLUN", "club_join_desc"],
    ["Özel kampanyalara katılım", "club_campaigns"],
    ["Her siparişinizde %15 e varan indirimler", "club_discounts"],
    ["SPA işbirliklerimizde indirim ve ayrıcalıklar", "club_spa"],
    ["Şimdi Katıl", "club_join"],
    ["Hesabınız var ise", "club_account"],
    ["Giriş Yapın", "club_signin"],
    ["Puan Toplama", "club_earn_title"],
    ["Her alışverişinizde puan toplayın ve bir sonraki siparişinizde indirim olarak kullanın", "club_earn_desc"],
    ["Nasıl Kazanırsınız?", "club_how_earn"],
    ["Nasıl Kullanırsınız?", "club_how_use"],
    ["Check out how you can earn points.", "club_earn_intro"],
    ["Check out what you can redeem your points for.", "club_use_intro"],
    ["Sign up", "club_signup"],
    ["Sipariş ver puan kazan", "club_place_order"],
    ["Order discount", "club_order_discount"],
    ["Sürekli Avantajlar", "club_benefits"],
    ["Size özel avantajlardan yararlanın!", "club_enjoy"],
    ["LSDS CLUB ENDLESS LOVE TIER", "club_tier_title"],
    ["La Sultane De Saba'nın en değerli müşterisi siz olun!", "club_valuable"],
    ["Sipariş tutarından bağımsız kalıcı %10 indirim", "club_discount10"],
    ["Sipariş tutarından bağımsız kalıcı %15 indirim", "club_discount15"],
    ["Yeni ürünlerin satın alımında öncelik", "club_priority"],
    ["Kapalı indirim kampanyalarına katılım", "club_private_sales"],
    ["Partner spa salonlarından bonuslar", "club_spa_bonus"],
    ["Geçmiş", "club_history"],
    ["Puan kazanıldı", "club_earned"],
    ["Puan indirildi", "club_deducted"],
    ["Puan kullanıldı", "club_redeemed"],
    ["Puanlar güncellendi", "club_adjusted"],
    ["Yeni VIP seviye", "club_tier_reached"],
    ["Points adjustment by admin", "club_admin_adjust"],
    ["Points expired", "club_expired"],
    ["Some items refunded or order canceled", "club_refund"],
    ["Unsubscribed", "club_unsubscribed"],
    ["Önce", "club_previous"],
    ["Sonra", "club_next"],
    ["Ödüller", "club_rewards"],
    ["İndirimler", "club_discounts_tab"],
    ["Ödül kazanılmamış", "club_no_rewards"],
    ["Kullanılmamış", "club_no_past"],
    ["Kullan", "club_apply"],
    ["Claim", "club_claim"],
    ["İptal", "club_cancel"],
    ["Get for free", "club_free"],
    ["Open product page", "club_open_product"],
    ["Discount will be applied to your cart.", "club_applied"],
    ["Discount isn't valid for the items in your cart.", "club_invalid"],
    ["Recipient's email", "club_recipient"],
    ["Cannot be used with other applied discounts", "club_combinations"],
    ["Sorry, there are no products in stock for this reward at the moment.", "club_out_of_stock"],
    ["- Choose a product -", "club_choose_product"],
    ["- Choose a variant -", "club_choose_variant"],
    ["Puan", "club_points_label"],
    ["Doğum Günü", "club_birthday"],
    ["Değiştirin", "club_edit"],
    ["Save", "club_save"],
    ["All set! Points will be added to your account on your birthday.", "club_birth_saved"],
    ["Subscribe", "club_subscribe"],
    ["You have successfully subscribed to the newsletter", "club_subscribed"],
    ["You're almost in! Check your email and confirm your subscription.", "club_confirm_email"],
    ["tier", "club_tier_label"],
    ["One-time rewards", "club_one_time"],
    ["daha harcayın ve", "club_tier_middle"],
    ["seviyesine ulaşarak daha fazla indirim ve avantajlardan yararlanın!", "club_tier_end"],
    ["Ulaşabileceğiniz en yüksek seviyedesiniz", "club_max_tier"],
    ["Ocak", "club_month_0"],
    ["Şubat", "club_month_1"],
    ["Mart", "club_month_2"],
    ["Nisan", "club_month_3"],
    ["Mayıs", "club_month_4"],
    ["Haziran", "club_month_5"],
    ["Temmuz", "club_month_6"],
    ["Agustos", "club_month_7"],
    ["Eylül", "club_month_8"],
    ["Ekim", "club_month_9"],
    ["Kasım", "club_month_10"],
    ["Aralık", "club_month_11"]
  ]);
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const giftNames = new Set([
    'Масло Карите Мускус/Ладан/Ваниль',
    'Shea Butter Musk Incense Vanilla (Udaipur)',
    'KARİTE YAĞI Misk, Tütsü ve Vanilya (Hindistan)'
  ]);
  const labels = new Map([
    ['Sort by', 'sort'], ['Bu üründen', 'points_prefix'],
    ['kazanabilirsiniz.', 'points_guest_end'],
    ['kazanıp bir sonraki siparişinizde kullanabilirsiniz.', 'points_member_end'],
    ['Giriş yap', 'sign_in'], ['Giriş Yapın', 'sign_in'], ['Ödüllerimi göster', 'rewards'],
    ['Spend 12.000 Tl and get your Shea Butter as a gift', 'gift_title'],
    ['Claim your free gift now!', 'gift_claim'], ['Hediyeni Al!', 'gift_button'],

  ]);
  const format = (key, values) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll('__' + name + '__', replacement), text[key]);
  function clubText(source) {
    const normalized = normalize(source);
    const bullet = normalized.startsWith('* ') ? '* ' : '';
    const key = clubLabels.get(bullet ? normalized.slice(2) : normalized);
    if (key) return bullet + text[key];
    let match;
    if ((match = normalized.match(/^([\d.,]+) points?$/))) {
      const number = Number(match[1].replace(/,/g, ''));
      const plural = new Intl.PluralRules(document.documentElement.lang || 'tr').select(number);
      return match[1] + (text['points_' + plural] || text.points_suffix);
    }
    const rules = [
      [/^Siparişinizdeki her (.+?) harcama için (\d+) kazanın$/, 'club_earn_rate', ['amount', 'points']],
      [/^(.+?) for every (\d+) points?$/, 'club_redeem_rate', ['amount', 'points']],
      [/^(.+?) (?:off|indirim)$/, 'club_discount_value', ['value']],
      [/^Apply (.+?) discount$/, 'club_apply_value', ['value']],
      [/^Claim (.+?) gift card$/, 'club_giftcard_value', ['value']],
      [/^Gift card was sent to (.+)$/, 'club_giftcard_sent', ['email']],
      [/^(\d+) points? left$/, 'club_points_left', ['points']],
      [/^Points expire on (.+)$/, 'club_expires', ['date']]
    ];
    for (const [pattern, target, names] of rules) {
      if ((match = normalized.match(pattern))) {
        const values = Object.fromEntries(names.map((name, i) => [name, match[i + 1]]));
        if (target === 'club_earn_rate' || target === 'club_redeem_rate') {
          const plural = new Intl.PluralRules(document.documentElement.lang || 'tr').select(Number(values.points));
          values.points += text['points_' + plural] || text.points_suffix;
        }
        return format(target, values);
      }
    }
    return undefined;
  }
  function localizeNode(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest('script, style, textarea, .jdgm-rev, .jdgm-rev__body, .jdgm-rev__title')) return;
    const raw = node.nodeValue;
    const source = raw.trim();
    if (!source) return;
    let translated;
    if (parent.closest('.AlLo-widget')) {
      translated = clubText(source);
    } else if (parent.closest('.ahlGiftBnrPrdTitle, .ahlGiftPopPrdTitle')) {
      if (giftNames.has(normalize(source)) && text.gift_product_title) translated = text.gift_product_title;
    } else if (parent.closest('.jdgm-widget')) {
      if (parent.matches('.jdgm-sort-dropdown-label') && source === 'Sort by') translated = text.sort;
    } else {
      const key = labels.get(source);
      if (key) translated = text[key];
      const points = source.match(/^([\d.,\s]+) puan$/);
      if (points && parent.closest('.AlLo-product-block')) {
        const number = Number(points[1].replace(/[,\s]/g, ''));
        const plural = new Intl.PluralRules(document.documentElement.lang || 'tr').select(number);
        translated = points[1] + (text['points_' + plural] || text.points_suffix);
      }

    }
    if (translated !== undefined && translated.trim() !== source) {
      node.nodeValue = translated.trim() === '.' ? raw.replace(source, '.').trimStart() : raw.replace(source, translated.trim());
    }
  }
  function localizeAttributes(element) {
    if (element.closest('.AlLo-widget')) {
      for (const attribute of ['aria-label', 'title', 'placeholder']) {
        const source = element.getAttribute(attribute);
        const translated = source ? clubText(source) : undefined;
        if (translated !== undefined && translated !== source) element.setAttribute(attribute, translated);
      }
    }
    if (element.matches('.ahlGiftBnrImg img') && element.getAttribute('alt') === 'Free Gift') {
      element.setAttribute('alt', text.club_free_gift);
    }
    if (element.matches('.swatch-view-item')) {
      const label = element.getAttribute('aria-label');
      if (label && label.endsWith(' - Sold Out') && text.sold_out !== 'Sold Out') element.setAttribute('aria-label', label.replace(/Sold Out$/, text.sold_out));
    }
    if (!element.closest('.jdgm-widget')) return;
    for (const attribute of ['aria-label', 'title', 'alt']) {
      const value = element.getAttribute(attribute);
      if (!value) continue;
      let translated;
      let match;
      if ((match = value.match(/^Average rating is ([\d.]+) stars$/))) translated = format('rating', { n: match[1] });
      else if ((match = value.match(/^([\d.]+%) \((\d+)\) reviews with (\d+) star rating$/))) translated = format('histogram', { percent: match[1], count: match[2], stars: match[3] });
      else if ((match = value.match(/^(\d+) star review$/))) translated = format('review_stars', { n: match[1] });
      else if ((match = value.match(/^Page (\d+)$/))) translated = format('page', { n: match[1] });
      else if ((match = value.match(/^Link to user picture (\d+)$/))) translated = format('picture', { n: match[1] });
      if (translated && translated !== value) element.setAttribute(attribute, translated);
    }
  }
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) localizeNode(node);
    localizeAttributes(root);
    root.querySelectorAll('[aria-label], [title], [alt], [placeholder]').forEach(localizeAttributes);
  }
  const pending = new Set();
  let queued = false;
  function collect(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const root = element.closest(scope);
    if (root) pending.add(root);
    else element.querySelectorAll(scope).forEach(item => pending.add(item));
    if (!pending.size || queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      const roots = [...pending];
      pending.clear();
      roots.forEach(root => { if (root.isConnected) translate(root); });
    });
  }
  collect(document.body);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'childList') record.addedNodes.forEach(collect);
      else collect(record.target);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'title', 'alt', 'placeholder'] });
})();

/* Approved 2026-10-26: widget interface labels only; preserve review and post content. */
(() => {
  const lang = document.documentElement.lang.split('-')[0];
  const dictionaries = {
    ru: {
      'Gift': 'Подарок',
      'Previous slide': 'Предыдущий слайд',
      'Next slide': 'Следующий слайд',
      'Review Image': 'Фото к отзыву',
      'previous post': 'Предыдущая публикация',
      'next post': 'Следующая публикация',
      'Go to Instagram post': 'Открыть публикацию в Instagram'
    },
    tr: {
      'Gift': 'Hediye',
      'Previous slide': 'Önceki slayt',
      'Next slide': 'Sonraki slayt',
      'Review Image': 'Yorum fotoğrafı',
      'previous post': 'Önceki gönderi',
      'next post': 'Sonraki gönderi',
      'Go to Instagram post': 'Instagram gönderisini aç'
    }
  };
  const dictionary = dictionaries[lang];
  if (!dictionary) return;
  const prefix = 'Instagram post with the caption:';
  const translatedPrefix = lang === 'ru' ? 'Публикация Instagram с подписью:' : 'Açıklamalı Instagram gönderisi:';
  const selectors = '.gift-trigger img, [class*="jdgm"] [aria-label], [class*="jdgm"] img[alt], [id*="instafeed"] img[alt], [class*="instafeed"] img[alt], [id*="instafeed"] [aria-label], [id*="instafeed"] [title], [class*="instafeed"] [aria-label], [class*="instafeed"] [title]';
  function translate() {
    document.querySelectorAll(selectors).forEach(element => {
      ['alt', 'aria-label', 'title'].forEach(attribute => {
        const original = element.getAttribute(attribute);
        if (!original) return;
        let replacement = dictionary[original];
        if (!replacement && original.startsWith(prefix)) {
          replacement = translatedPrefix + original.slice(prefix.length);
        }
        if (replacement && original !== replacement) element.setAttribute(attribute, replacement);
      });
    });
  }
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; translate(); });
  });
  function start() {
    translate();
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['alt', 'aria-label', 'title'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
